import { EmbedSettingsAvailableFeatures } from "./embed-helpers/EmbedHelperV7";
import { EntryType } from "@kaltura/mediaspace-shared-types";

export enum AllowLocalNetworkAccessValue {
    Off = "0",
    On = "1",
    All = "all",
}

export interface EmbedSettings {
    playerDisplayName: string;
    playerId: string;
    isPlayerV7: boolean;
    entryType: EntryType;
    embedSizes: string[];
    libUrl: string;
    entryId: string;
    selectedEmbedSize?: string;
    isDefault?: boolean;
    isAutoPlay?: boolean;
    isThumbnailEmbed?: boolean;
    uiConfPluginVersions?: string;
}

/**
 * "static" props used for generating embed code
 */
export interface EmbedCodeProps {
    host: string;
    partnerId: number;
    secureEmbed?: boolean;
    omitSandboxOnIframe?: boolean;
    allowLocalNetworkAccess?: AllowLocalNetworkAccessValue;
    title?: string;
}

export interface PlayerConfig {
    wid: string;
    entry_id: string;
}

export interface EmbedCodeTokens {
    WIDGET_ID: string;
    WIDTH: number | string;
    HEIGHT: number | string;
    HOST: string;
    PARTNER_ID: number;
    UICONF_ID: string;
    ENTRY_ID?: string;
    PLAYLIST_ID?: string;
    OMIT_SANDBOX: boolean;
    ALLOW_LOCAL_NETWORK_ACCESS: AllowLocalNetworkAccessValue;
    TITLE: string;
    UICONF_PLUGIN_VERSIONS?: string;
    RESPONSIVE?: boolean;
    PLAYBACK_CONTEXT?: string;
    START_TIME?: number;
    END_TIME?: number;
}

export interface SettingsFormProps {
    embedSettings: EmbedSettings[];
    availableFeatures?: EmbedSettingsAvailableFeatures;
    embedCodeParams: EmbedCodeProps;
    playerConfig: PlayerConfig;
    onClose: () => void;
}
